import { functions } from "../firebase";

export type CoachReportRoom = {
  groupJid: string;
  groupName: string | null;
  role: "primary" | "report_only";
};

export type CoachReportRooms = {
  communityId: string;
  rooms: number;
  roomDetails: CoachReportRoom[];
};

export type CoachReportRoomUnlinked = {
  ok: true;
  communityId: string;
  rooms: {
    groupJid: string;
    groupName: string | null;
    role: "primary" | "report_only";
    action: "disabled" | "report_removed";
    revoking: boolean;
  }[];
};

export const listCoachReportRooms = async (
  communityId: string
): Promise<CoachReportRooms> => {
  const callable = functions.httpsCallable("adminListCoachReportRooms");
  const result = await callable({ communityId });
  return result.data as CoachReportRooms;
};

export const unlinkCoachReportRoom = async (params: {
  communityId: string;
  groupJid: string;
}): Promise<CoachReportRoomUnlinked> => {
  const callable = functions.httpsCallable("adminUnlinkCoachReportRoom");
  const result = await callable(params);
  return result.data as CoachReportRoomUnlinked;
};
